import { render, staticRenderFns } from "./HmiReguladores1.vue?vue&type=template&id=5d5f4870&lang=true"
import script from "./HmiReguladores1.vue?vue&type=script&lang=js"
export * from "./HmiReguladores1.vue?vue&type=script&lang=js"
import style0 from "./HmiReguladores1.vue?vue&type=style&index=0&id=5d5f4870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports